module.exports = __webpack_public_path__ + "img/4.36cce775.jpeg";